package com.gsb.vyapar.bhagya.presentation.common.toolbar

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material.Icon
import org.jetbrains.compose.resources.painterResource
import com.gsb.vyapar.bhagya.theme.arrow_back
import com.gsb.vyapar.bhagya.theme.edit_icon
import com.gsb.vyapar.bhagya.theme.delete_icon
import com.gsb.vyapar.bhagya.theme.search_icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.common.text.Text16Medium
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.presentation.search.uistate.getSearchUiState
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.white

@Composable
fun Toolbar(title: String, onBackPress: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(50.dp)
            .background(color = primary)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(arrow_back),
                contentDescription = "Back",
                tint = white,
                modifier = Modifier.clickable { onBackPress() }
            )
        }
        Text16Medium(text = title, color = white)
    }
}

@Composable
fun Toolbar(title: String) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(50.dp)
            .background(color = primary)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(arrow_back),
                contentDescription = "Back",
                tint = white,
                modifier = Modifier.clickable { popView() }
            )
        }
        Text16Medium(text = title, color = white)
    }
}

@Composable
fun ToolbarEdit(title: String, onEditPress: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(50.dp)
            .background(color = primary)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(arrow_back),
                contentDescription = "Back",
                tint = white,
                modifier = Modifier.clickable { popView() }
            )
        }
        Text16Medium(text = title, color = white)
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.End,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(edit_icon),
                contentDescription = "Edit",
                tint = white,
                modifier = Modifier.clickable { onEditPress() }
            )
        }
    }
}

@Composable
fun ToolbarDelete(title: String, onDeletePress: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(50.dp)
            .background(color = primary)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(arrow_back),
                contentDescription = "Back",
                tint = white,
                modifier = Modifier.clickable { popView() }
            )
        }
        Text16Medium(text = title, color = white)
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.End,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(delete_icon),
                contentDescription = "Delete",
                tint = white,
                modifier = Modifier.clickable { onDeletePress() }
            )
        }
    }
}

@Composable
fun ToolbarSearch(title: String) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(50.dp)
            .background(color = primary)
            .padding(horizontal = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(arrow_back),
                contentDescription = "Back",
                tint = white,
                modifier = Modifier.clickable { popView() }
            )
        }
        Text16Medium(text = title, color = white)
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.End,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(search_icon),
                contentDescription = "Search",
                tint = white,
                modifier = Modifier.clickable {
                    getSearchUiState().resetSearch()
                    pushView(Screens.Search)
                }
            )
        }
    }
}